module.exports = __webpack_public_path__ + "static/img/Tom-Rogic.4914706.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom-Rogic.jpg
// module id = IbVe
// module chunks = 0